/** Text reviews of the product page: quiet filter tabs and "show more" paging over server-rendered items. */
class LucidProductReviews extends HTMLElement {
  #filter = 'all';
  #shown = 5;

  connectedCallback() {
    this.#shown = this.#page;
    this.querySelectorAll('[data-review][data-paged]').forEach((item) => item.removeAttribute('data-paged'));
    this.addEventListener('click', this.#onClick);
    this.querySelector('[role="tablist"]')?.addEventListener('keydown', this.#onKeydown);
    this.#render();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  get #page() {
    return Math.max(Number(this.dataset.page || 5), 1);
  }

  #matches(item) {
    if (this.#filter === 'wash') return item.dataset.wash === 'true';
    if (this.#filter === 'fit') return item.dataset.fit === 'true';
    return true;
  }

  #render(from = -1) {
    const items = Array.from(this.querySelectorAll('[data-review]'));
    const matching = items.filter((item) => this.#matches(item));
    items.forEach((item) => {
      item.hidden = true;
      item.classList.remove('is-new');
    });
    matching.slice(0, this.#shown).forEach((item, index) => {
      item.hidden = false;
      if (from > -1 && index >= from) {
        item.classList.add('is-new');
        item.style.setProperty('--lc-i', String(index - from));
      }
    });
    const rest = matching.length - Math.min(this.#shown, matching.length);
    const more = this.querySelector('[data-more]');
    if (more instanceof HTMLElement) more.hidden = rest <= 0;
    const end = this.querySelector('[data-end]');
    if (end instanceof HTMLElement) end.hidden = rest > 0 || matching.length <= this.#page;
  }

  #select(tab) {
    this.querySelectorAll('[data-filter]').forEach((button) => {
      const on = button === tab;
      button.setAttribute('aria-selected', String(on));
      button.tabIndex = on ? 0 : -1;
    });
    this.#filter = tab.getAttribute('data-filter') || 'all';
    this.#shown = this.#page;
    this.#render(0);
  }

  #onClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const tab = target?.closest('[data-filter]');
    if (tab) {
      this.#select(tab);
      return;
    }
    if (target?.closest('[data-more]')) {
      const from = this.#shown;
      this.#shown += this.#page;
      this.#render(from);
      const next = Array.from(this.querySelectorAll('[data-review]:not([hidden])'))[from];
      if (next instanceof HTMLElement) {
        next.tabIndex = -1;
        next.focus({ preventScroll: true });
      }
    }
  };

  #onKeydown = (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const tabs = Array.from(this.querySelectorAll('[data-filter]'));
    const index = tabs.indexOf(document.activeElement);
    if (index < 0) return;
    event.preventDefault();
    const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    next.focus();
    this.#select(next);
  };
}

if (!customElements.get('lucid-product-reviews')) customElements.define('lucid-product-reviews', LucidProductReviews);
